import { ActionTypes } from "../../../constants";

export const selectMenuItem = (id) => ({
  type: ActionTypes.SELECT_MENU_ITEM,
  id
});

export default {};